let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9LI4y")).then(() => parcelRequire('lnvJ5'));